import { Outlet } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { needsSecurityOnboarding } from "@/lib/brokerAuth";
import { SecurityOnboarding } from "@/pages/SecurityOnboarding";

// Layout nested inside ProtectedRoute (so it only ever runs for an authenticated
// broker). Once the broker's security posture (PMS-S073) has loaded, if they lack
// a strong sign-in factor and haven't dismissed the prompt this session, it
// renders the guided "secure your account" interstitial in place of the requested
// page; otherwise the page renders as normal (BRK-S026). It deliberately doesn't
// redirect — it swaps content at the current URL — so dismissing or enrolling
// reveals the page the broker was headed to with no extra navigation.
//
// While the first posture read is in flight we render a brief loading state so we
// don't flash the page and then yank it away for the prompt. A failed/absent
// posture read leaves posture null, and needsSecurityOnboarding declines to prompt
// (the fail-safe), so this stays a no-op against a PMS not serving PMS-S073.
export function SecurityOnboardingGate() {
  const { posture, postureReady, securityPromptDismissed } = useAuth();

  if (!postureReady) {
    return (
      <p role="status" className="py-16 text-center text-brk-dim">
        Loading…
      </p>
    );
  }

  if (needsSecurityOnboarding(posture) && !securityPromptDismissed) {
    return <SecurityOnboarding />;
  }

  return <Outlet />;
}
